import React, { useState } from 'react';
import './bootstrap.css';
import { fetchAndNormalize } from './api/materials';
import MaterialDetailModal from './MaterialDetailModal';
import { DEFAULT_ANSWERS, QUESTIONS, scoreByQuestions } from './api/materialQuizConfig';

export default function Form() {
  const [answers, setAnswers] = useState(DEFAULT_ANSWERS);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [noMatches, setNoMatches] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setAnswers((s) => ({ ...s, [name]: value }));
  };

  function scoreMaterial(m) {
    return scoreByQuestions({ materialCode: m?.code, answers });
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResults(null);
    try {
      const list = await fetchAndNormalize();
      const scored = list.map((m) => ({ m, score: scoreMaterial(m) }));
      const withPositive = scored.filter(s => s.score > 0).sort((a,b) => b.score - a.score);
      if (withPositive.length > 0) {
        setResults(withPositive);
        setNoMatches(false);
      } else {
        setResults([]);
        setNoMatches(true);
      }
    } catch (err) {
      setError('Błąd podczas pobierania materiałów. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const closeModal = () => setSelectedMaterial(null);

  const reset = () => {
    setAnswers(DEFAULT_ANSWERS);
    setResults(null);
    setError(null);
    setNoMatches(false);
  };

  const visibleResults = results ? results.filter(r => (r && typeof r.score === 'number' ? r.score > 0 : false)) : null;

  return (
    <div className="container py-4">
      <h2 className="mb-3 text-center">Formularz doboru materiału</h2>

      <form onSubmit={onSubmit}>
        <div className="row g-3">
          {QUESTIONS.map((q) => (
            <div key={q.id} className="col-12 col-md-6">
              <label className="form-label">{q.label}</label>
              {(() => {
                const currentValue = answers[q.id] ?? DEFAULT_ANSWERS?.[q.id] ?? q.options?.[0]?.value ?? ''
                return q.type === 'radio' ? (
                  <div>
                    {q.options.map((opt) => {
                      const id = `${q.id}-${opt.value}`
                      return (
                        <div key={opt.value} className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={q.id}
                            id={id}
                            value={opt.value}
                            checked={currentValue === opt.value}
                            onChange={onChange}
                          />
                          <label className="form-check-label" htmlFor={id}>{opt.label}</label>
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  <select className="form-select" name={q.id} value={currentValue} onChange={onChange}>
                    {q.options.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                )
              })()}
            </div>
          ))}

          <div className="col-12 d-flex gap-2">
            <button type="submit" className="btn btn-primary fw-bold" disabled={loading}>
              {loading ? 'Szukam...' : 'Proponuj materiały'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={reset} disabled={loading}>Reset</button>
          </div>
        </div>
      </form>

      <hr className="my-4" />

      {error && <div className="alert alert-danger">{error}</div>}

      {results && (
        <div>
          <h3>Propozycje ({visibleResults ? visibleResults.length : 0})</h3>
          <div className="row g-3">
            {(visibleResults || []).map(({ m, score }) => (
              <div key={m.id} className="col-12 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">{m.name} <small className="text-muted">({m.code || '-'})</small></h5>
                    <p className="card-text mb-1">Dopasowanie: <strong>{score}</strong></p>
                    <p className="card-text small text-muted">
                      Temp: {m.temp_min ?? '-'} — {m.temp_max ?? '-'} °C • Gęstość: {m.density ?? '-'}
                    </p>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-primary btn-sm" onClick={() => setSelectedMaterial(m)}>Szczegóły</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {(!visibleResults || visibleResults.length === 0) && noMatches && (
              <div className="col-12">
                <div className="alert alert-warning">Przy takich ustawieniach nie da się zaproponować materiału.</div>
              </div>
            )}
            {(!visibleResults || visibleResults.length === 0) && !noMatches && <div className="col-12 text-muted">Brak dopasowań.</div>}
          </div>
        </div>
      )}

      {selectedMaterial && <MaterialDetailModal material={selectedMaterial} onClose={closeModal} />}

    </div>
  );
}